PJQ.views.productionQuantities.ProductionQuantitiesList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'production-quantities-list'),
        productionQuantityId: null
    },
    events: {
        'click .btn-add-production-quantity': 'addProductionQuantity',
        'click .add-budgeted-quantities': 'addBudgetedQuantities',
        'click .add-installed-quantities': 'addInstalledQuantities',
        'click .btn-delete-production-quantity': 'deleteProductionQuantityClicked',
        'click .btn-export': 'export'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canAdd = this.options.project.permissions.hasPermission('productionQuantities.canAdd');
        this.options.canEdit = this.options.project.permissions.hasPermission('productionQuantities.canEdit');
        this.options.isAdmin = this.options.project.permissions.hasPermission('productionQuantities.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            canAdd: this.options.canAdd,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            hideHeader: this.options.hideHeader
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('productionQuantityChanged');
        PJQ.app.session.project.on('productionQuantityChanged', function (productionQuantity) {
            this.collection.add(productionQuantity);
            this.render();
        }, this);

        if (this.options.productionQuantityId > 0) {
            let initProductionQuantity = this.collection.get(this.options.productionQuantityId);
            if (initProductionQuantity != null) {
                this.viewProductionQuantity(initProductionQuantity);
                this.options.productionQuantityId = null;
            }
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = new PJQ.views.productionQuantities.ProductionQuantitiesDatatable({
            el: this.$('.production-quantities-data'),
            rowId: "cid",
            data: this.collection.models,
            paging: false,
            isAdmin: this.options.isAdmin,
            orderCookie: PJQ.constants.cookies.PRODUCTION_QUANTITIES_ORDER_COOKIE,
            columnWidthCookie: PJQ.constants.cookies.PRODUCTION_QUANTITIES_COLUMNS_WIDTH,
            costCodes: this.costCodes,
            unitsOfMeasure: this.unitsOfMeasure,
            subJobs: this.subJobs,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin,
                    canAdd: this.options.canAdd,
                    canEdit: this.options.canEdit
                };
            }, this),
            onDeleteProductionQuantity: (productionQuantity) => {
                this.deleteProductionQuantity(productionQuantity);
            },
            order: [[1, 'asc']],
            onViewProductionQuantity: (productionQuantity) => {
                this.viewProductionQuantity(productionQuantity);
            },
            onRowDoubleClick: (row) => {
                this.viewProductionQuantity(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewProductionQuantity(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        onClick: (row) => {
                            this.deleteProductionQuantity(row.data());
                        },
                        isDanger: true,
                        isShown: (row) => {
                            return this.options.isAdmin;
                        }
                    }
                ]
            }
        });
    },
    export: function (e) {
        let $target = $(e.currentTarget),
            type = $target.data('type');

        if (this.options.project == null) {
            return;
        }

        let orderCookie = PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.PRODUCTION_QUANTITIES_ORDER_COOKIE),
            order = orderCookie != null ? JSON.parse(orderCookie) : null,
            report = new PJQ.models.reports.NewReport({
            type: PJQ.constants.reports.reportTypes.PRODUCTION_QUANTITIES.type,
            projectId: this.options.project ? this.options.project.id : null,
            options: {
                columns: ["subJob", "costCode", "quantity", "installedQuantity", "unit", "description"],
                columnOrder: order,
            }
        });

        report.export({format: type?.toLowerCase() ?? "pdf" });
    },
    viewProductionQuantityClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewProductionQuantity(row.data());
    },
    viewProductionQuantity: function (productionQuantity) {
        let isNew = productionQuantity == null;

        new PJQ.views.productionQuantities.ProductionQuantityEditModal({
            model: productionQuantity,
            onSave: _.bind(function (productionQuantity) {
                if (isNew) {
                    this.collection.add(productionQuantity);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (productionQuantity) {
                this.collection.remove(productionQuantity);
                this.renderView();
            }, this)
        });
    },
    addBudgetedQuantities: function () {
        new PJQ.views.productionQuantities.ProductionQuantitiesAddModal({
            project: this.options.project,
            onSave: (productionQuantities) => {
                this.collection.add(productionQuantities);
                this.renderView();
            }
        });
    },
    addInstalledQuantities: function () {
        new PJQ.views.productionQuantities.InstalledQuantitiesAddModal({
            project: this.options.project,
            onSave: (newQuantities) => {
                _.each(newQuantities, (quantity) => {
                    let productionQuantity = this.collection.get(quantity.productionQuantityId);

                    if(productionQuantity != null){
                        productionQuantity.installedQuantities.add(quantity);
                    }
                });

                this.renderView();
            }
        });
    },
    deleteProductionQuantityClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteProductionQuantity(row.data());
    },
    deleteProductionQuantity: function (productionQuantity) {
        let row = this.dataTable.getRow(productionQuantity.cid);

        if (row != null) {
            new PJQ.views.modals.DeleteCancel({
                header: "Delete Production Quantity",
                body: "Are you sure you want to delete this Production Quantity?",
                onDelete: _.bind(function () {
                    productionQuantity.destroy({
                        success: _.bind(function () {
                            this.dataTable.removeRow(row);
                            if (typeof this.options.onDelete === 'function') {
                                this.options.onDelete(productionQuantity);
                            }
                        }, this)
                    });
                }, this)
            });
        }
    }
});